import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import RenderFilterForm from "../../utils/filterForm";

class FilterForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    error: PropTypes.string
  };

  render() {
    const fields = [
      {'name': 'id', 'label': 'ID', 'placeholder': 'ID', 'type': 'number'},
      {'name': 'title', 'label': 'Title', 'placeholder': 'Title', 'type': 'text'},
    ];

    return (
      <RenderFilterForm {...this.props} fields={fields} />
    );
  }
}

export default reduxForm({
  form: 'filter_templates',
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})(FilterForm);
